import { Avatar, Box, Button, Divider, Menu, Stack, Text, UnstyledButton } from '@mantine/core';
import { LogOutIcon } from 'lucide-react';
import type { Member } from 'stytch';

export function ProfileMenu({ member }: { member?: Member | null }) {
  if (member === undefined) return null;

  if (member === null) {
    return (
      <Button variant="default" component="a" href="/login">
        Log in
      </Button>
    );
  }

  const { email_address, name } = member;

  return (
    <Menu trigger="click-hover" withArrow shadow="md" offset={4}>
      <Menu.Target>
        <Avatar component={UnstyledButton} size="sm" name={name} color="initials" />
      </Menu.Target>
      <Menu.Dropdown miw={200}>
        <Stack gap="0.25rem">
          <Box px="sm" py="xs">
            <Text size="sm" fw={500}>
              {name}
            </Text>
            <Text size="xs" c="dimmed">
              {email_address}
            </Text>
          </Box>
          <Divider />
          <Menu.Item
            component="a"
            href="/auth/logout"
            leftSection={<LogOutIcon size={14} />}
            color="red"
          >
            Logout
          </Menu.Item>
        </Stack>
      </Menu.Dropdown>
    </Menu>
  );
}
